import {
  optimisationChartBuilder,
  OptimisationChartContext,
  OptimisationChartDataContext,
} from 'components/Charting/Optimisation/OptimisationChartBuilder';
import { useChart } from 'components/Charting/useChart';
import { TradedVolumeContainer } from 'pages/Optimisation/components/ContractedVolume/ContractedVolume.styled';
import { useStore } from 'store';

const config: OptimisationChartContext['config'] = {
  chartName: 'ContractedVolumeChart',

  // min required for correct internal chart display,
  // plus additional for external spacing per design requirements
  margin: { left: 70 + 24, top: 8 + 40, bottom: 32 + 0, right: 20 + 24 },

  getFormattedYLabelValue: (input) => input?.toString(),
};

export const OptimisationChart = ({
  fullScreen,
  dataContext,
}: {
  fullScreen: boolean;
  dataContext: OptimisationChartDataContext | undefined;
}) => {
  const { chartRef, ErrorPlaceholder } = useChart(
    config,
    optimisationChartBuilder,
    dataContext,
  );

  const [appTheme] = useStore((state) => [state.appTheme]);

  return (
    <TradedVolumeContainer
      ref={chartRef}
      $fullScreen={fullScreen}
      $appTheme={appTheme}
    >
      <ErrorPlaceholder />
    </TradedVolumeContainer>
  );
};
